<div>
    <div *ngIf="this.isLoadingCardList" class="flex justify-center items-center h-[245px]">
        <p-progress-spinner ariaLabel="loading" />
    </div>
    <!-- Cards -->
    <div *ngIf="(this.cards!.length == 0 && !isNewCard) && !this.isLoadingCardList" class="flex justify-center items-center h-[245px]">
        <!-- No Credit Cards-->
        <p-card class="text-center font-[DMSans] text-[16px] font-bold shadow-xl shadow-cyan-500/5">
            <p>
                You have no credit cards saved. 
            </p>
            <p>
                Select Add Credit Card to add a new card.
            </p>
        </p-card> 
    </div>
    <div *ngIf="(this.cards!.length > 0 || isNewCard) && !this.isLoadingCardList">
        <!-- Web Carousel -->
        <div class="hidden lg:flex mt-[30px] w-full justify-center" *ngIf="!isEditing">
            <div class="max-w-[1000px] flex-row">
                <p-carousel #carouselWeb ngSkipHydration [value]="this.cards!" [numVisible]="2" [numScroll]="2" [circular]="false" [showIndicators]="false">
                    <ng-template let-card #item (click)="scrollToSelected()">
                        <app-credit-card-item 
                            [card]="card"
                            [isWebComponent]="true"
                            [showCheckBox]="true"
                            [isEditing]="isEditing"
                            [cardHolderFormValue]="cardHolderFormValue"
                            [cardNumberFormValue]="cardNumberFormValue"
                            [selectedCard]="selectedCard"
                            [monthFormValue]="monthFormValue"
                            [yearFormValue]="yearFormValue"
                            (turnEditMode)="turnEditMode($event)"
                            (confirmDelete)="confirmDelete($event)"
                            (onSelectCardWeb)="onSelectCardWeb($event)"
                            (onCheckboxChange)="onCheckboxChange($event)">
                        </app-credit-card-item>
                    </ng-template>
                </p-carousel>
            </div>
        </div>

        <!-- Mobile Carousel-->
        <div class="lg:hidden" *ngIf="!isEditing && !isCreditCardSelectedOnMobile">
            <div class="block mt-[30px]">
                <p-carousel #carouselMobile ngSkipHydration [value]="this.cards!" [numVisible]="1.5" [numScroll]="1.5" [circular]="false" [showIndicators]="false"  [showNavigators]="false" orientation="vertical" verticalViewPortHeight="400px">
                    <ng-template let-card #item  (click)="scrollToSelected()">
                        <app-credit-card-item
                            [card]="card"
                            [isWebComponent]="false"
                            [isEditing]="isEditing"
                            [showCheckBox]="false"
                            [cardHolderFormValue]="cardHolderFormValue"
                            [cardNumberFormValue]="cardNumberFormValue"
                            [selectedCard]="selectedCard"
                            [monthFormValue]="monthFormValue"
                            [yearFormValue]="yearFormValue"
                            (turnEditMode)="turnEditMode($event)"
                            (confirmDelete)="confirmDelete($event)"
                            (onSelectCardMobile)="onSelectCardMobile($event)">
                        </app-credit-card-item>                    
                    </ng-template>
                </p-carousel>
            </div>
        </div>

        <!-- Mobile View/Edit Credit Card -->
        <div class="lg:hidden" *ngIf="isCreditCardSelectedOnMobile && !isNewCard">
            <app-credit-card-item 
                [card]="selectedCard"
                [isWebComponent]="false"
                [showCheckBox]="true"
                [isEditing]="isEditing"
                [isAlwaysVisibleCheckBox]="true"
                [cardHolderFormValue]="cardHolderFormValue"
                [cardNumberFormValue]="cardNumberFormValue"
                [selectedCard]="selectedCard"
                [monthFormValue]="monthFormValue"
                [yearFormValue]="yearFormValue"
                (turnEditMode)="turnEditMode($event)"
                (confirmDelete)="confirmDelete($event)"
                (onCheckboxChange)="onCheckboxChange($event)">
            </app-credit-card-item>        
        </div>

        <!-- Web Edit Credit Card -->
        <div class="" *ngIf="!isSmallScreen && isEditing && !isNewCard">
            <app-credit-card-item 
                [card]="selectedCard"
                [isWebComponent]="false"
                [showCheckBox]="true"
                [isEditing]="isEditing"
                [isAlwaysVisibleCheckBox]="true"
                [selectedCard]="selectedCard"
                [cardHolderFormValue]="cardHolderFormValue"
                [cardNumberFormValue]="cardNumberFormValue"
                [monthFormValue]="monthFormValue"
                [yearFormValue]="yearFormValue"
                (turnEditMode)="turnEditMode($event)"
                (confirmDelete)="confirmDelete($event)"
                (onCheckboxChange)="onCheckboxChange($event)">
            </app-credit-card-item>        
        </div>

        <!-- Web/Mobile - Add Credit Card -->
        <div class="lg:w-full lg:flex lg:justify-center lg:items-center" *ngIf="isEditing && isNewCard">
            <app-credit-card-item 
                [card]="selectedCard"
                [isWebComponent]="!isSmallScreen"
                [showCheckBox]="false"
                [isEditing]="isEditing"
                [isAlwaysVisibleCheckBox]="true"
                [selectedCard]="selectedCard"
                [cardHolderFormValue]="cardHolderFormValue"
                [cardNumberFormValue]="cardNumberFormValue"
                [monthFormValue]="monthFormValue"
                [yearFormValue]="yearFormValue"
                (turnEditMode)="turnEditMode($event)"
                (confirmDelete)="confirmDelete($event)"
                (onCheckboxChange)="onCheckboxChange($event)">
            </app-credit-card-item>        
        </div>
    </div>
    
    <!-- Card Info Form -->
    <div 
    [ngClass]="{ 'hidden': !(isCreditCardSelectedOnMobile || !isSmallScreen)}">
        <app-credit-cards-info-form
            [id]="id"
            [isEditing]="isEditing"
            [isNewCard]="isNewCard"
            [(isLoadingCardList)]="isLoadingCardList"
            [isSmallScreen]="isSmallScreen"
            [selectedCard]="selectedCard"
            [creditCardsList]="cards"
            (creditCardsListChange)="cards = $event"
            (selectedCardChange)="selectedCardChange($event)"
            (turnEditMode)="turnEditMode($event)"
            (printCardHolderName)="printCardHolder($event)"
            (printCardNumber)="printCardNumber($event)"
            (printMonth)="printMonth($event)"
            (printYear)="printYear($event)">
        </app-credit-cards-info-form>
    </div>

    <!-- Add Credit Card Mobile-->
    <div class="lg:hidden" *ngIf="!isEditing && !isCreditCardSelectedOnMobile">
        <div class="flex mt-[60px] justify-center" >
            <button pButton type="button" (click)="openAddCreditCardModal()" class="font-noto-serif w-full h-9 max-w-[338px]"  >
                Add Credit Card
            </button>
        </div>
    </div>


</div>
